/**
 * The pure simulation tick. Advances the world by one fixed `dt` and returns the
 * events that occurred, for the render/UI/audio layers to consume. No Babylon,
 * no DOM, no wall-clock — fully deterministic and serializable.
 */
import type { SimState, SimInput, SimConfig, SimEvent } from './types.js';
import type { LevelDef } from '../level/types.js';
import { updatePlayer } from './player.js';
import { updateInteraction } from './interaction.js';

export function step(
  state: SimState,
  input: SimInput,
  dt: number,
  level: LevelDef,
  cfg: SimConfig,
): SimEvent[] {
  const events: SimEvent[] = [];
  state.t += dt;

  // Once the scene is complete, freeze the simulation.
  if (state.complete) return events;

  updatePlayer(state, input, dt, level, cfg, events);
  updateInteraction(state, input, level, cfg, events);

  return events;
}
